import createMaterialUIPlugin from './materialUi';
import createSaveToPdfPlugin from './saveToPdf';
import createTableOfContentsPlugin from './tableOfContents';
import createTitleWithTOC from './tableOfContents/createTitleWithToc';
import createWrappedComponent from './wrapComponent';
import createTableEditor from './table';
import createPageReferencePlugin from './pageReference';
import createAnsprechpartnerPlugin from './ansprechpartner';
import createCollapsiblePlugin from './collapsible';
import createContactPlugin from './contact';
import createDividerPlugin from './sectionDivider';
import createAddToCalendarPlugin from './addToCalendar';
import createDatepickerPlugin from './datepicker';
import createSetPageTitlePlugin from './setPageTitle';
import createBlockToPageDataPlugin from './blockToPageData';
import TableRenderer from '../../TableRenderer';
import PriceChartRenderer from '../../PriceChartRenderer';

const setPageTitle = createSetPageTitlePlugin();
const updatePageData = createBlockToPageDataPlugin([
  ['first-paragraph', 'abstract'],
  ['subtitle', 'subtitle'],
  ['place', 'place'],
  ['email', 'email'],
  ['address', 'address'],
  ['phone', 'phone'],
  ['website', 'website'],
  // ['title', 'title'],
]);

const tableOfContentsPlugin = createTableOfContentsPlugin({
  blockTypes: ['header-one'],
});
const tableOfContentWrap = createWrappedComponent({
  blockTypes: ['title'],
  wrap: createTitleWithTOC({ readOnly: false }),
});
const materialUIPlugin = createMaterialUIPlugin();
const saveToPdfPlugin = createSaveToPdfPlugin();

const tablePlugin = createTableEditor({
  identifier: 'table-editor',
  data: [
    [{ value: 'Titel eingeben' }, { value: 'Titel eingeben' }],
    [{ value: 'Text eingeben' }, { value: 'Text eingeben' }],
  ],
  dataRenderComponent: TableRenderer,
});

const columns = [
  'Zeitpunkt',
  'Pellets',
  'Heizöl',
  'Erdgas',
  'Flüssiggas',
  'Fernwärme',
  'Wärmepumpe',
];
const priceChartPlugin = createTableEditor({
  identifier: 'price-chart',
  data: [
    columns.map(m => ({ value: m })),
    [
      { value: 'Zeitpunkt A' },
      { value: '1,4' },
      { value: '2,1' },
      { value: '3,5' },
      { value: '2,7' },
      { value: '1,5' },
      { value: '1,9' },
    ],
    [
      { value: 'Zeitpunkt B' },
      { value: '2,4' },
      { value: '3,6' },
      { value: '1,8' },
      { value: '2,3' },
      { value: '3,5' },
      { value: '1,8' },
    ],
    [
      { value: 'Zeitpunkt C' },
      { value: '3,1' },
      { value: '1,9' },
      { value: '2,8' },
      { value: '1,7' },
      { value: '2,1' },
      { value: '1,5' },
    ],
  ],
  dataRenderComponent: PriceChartRenderer,
});

const pageReferencePlugin = createPageReferencePlugin();
const ansprechpartnerPlugin = createAnsprechpartnerPlugin();
const contactPlugin = createContactPlugin();
const dividerPlugin = createDividerPlugin();
const collapsiblePlugin = createCollapsiblePlugin();
const addToCalendar = createAddToCalendarPlugin();
const datepickerPlugin = createDatepickerPlugin();

const plugins = [
  materialUIPlugin,
  saveToPdfPlugin,
  tableOfContentsPlugin,
  tableOfContentWrap,
  tablePlugin,
  pageReferencePlugin,
  ansprechpartnerPlugin,
  contactPlugin,
  dividerPlugin,
  priceChartPlugin,
  addToCalendar,
  datepickerPlugin,
  setPageTitle,
  updatePageData,
  // this should be last plugin
  collapsiblePlugin,
];

export default plugins;
